'use strict';

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var regexParts = {
  indentation: '^([ \t]*)',
  fName: '([\\w\\.]+)',
  paramList: '\\(([\\w,=\'"\\{\\}: ]*?)\\)',
  paramListArrow: '\\(?([\\w,=\'"\\{\\}: ]*?)\\)?',
  comment: '((?:(?:[^\n]*(?:\\/\\/|\\/\\*|\\*)\\s*.*\n)+)?)',
  async: '(?:(async)?)'

  /**
   * Find functions
   * @param {string} source
   * @returns {Object[]}
   */
};function findFunctions(source) {
  var indentation = regexParts.indentation,
      fName = regexParts.fName,
      paramList = regexParts.paramList,
      paramListArrow = regexParts.paramListArrow,
      comment = regexParts.comment,
      async = regexParts.async;

  var regex = new RegExp('' + comment + indentation + async + '[^,\n(]*?' + fName + '\\s*?' + paramList + '\\s*?\\{', 'gm');

  var match = void 0;

  var functions = [];
  // eslint-disable-next-line no-cond-assign
  while (match = regex.exec(source)) {
    var func = {
      pos: match.index,
      full: match[0],
      async: !!match[3],
      name: match[4].split('.').pop(),
      indentation: match[2],
      params: extractParams(match[5]),
      paramString: match[5],
      hasBody: true,
      comment: match[1],
      body: {
        start: match.index + match[0].length,
        end: findEnd(source, match.index + match[0].length)
      }
    };
    functions.push(func);
  }

  regex = new RegExp('' + comment + indentation + '.*?' + fName + '\\s*?=\\s*' + async + '\\s*' + paramListArrow + '\\s*?=>\\s*(\\{?)', 'gm');
  // eslint-disable-next-line no-cond-assign
  while (match = regex.exec(source)) {
    var _func = {
      pos: match.index,
      full: match[0],
      async: !!match[4],
      name: match[3].split('.').pop(),
      indentation: match[2],
      params: extractParams(match[5]),
      paramString: match[5],
      hasBody: !!match[6],
      comment: match[1],
      body: {
        start: match.index + match[0].length,
        end: match[6] ? findEnd(source, match.index + match[0].length) : match.index + match[0].length
      }
    };
    functions.push(_func);
  }

  return functions.filter(function (_ref) {
    var name = _ref.name;
    return !name.match(/^(for|if|while}|catch)/);
  }).sort(function (a, b) {
    return a.pos - b.pos;
  });
}

/**
 * Find end
 * @param {string} src
 * @param {number} bodyStart
 * @returns {number}
 */
function findEnd(src, bodyStart) {
  var stack = ['{'];
  var lastStringStart = void 0;
  for (var i = bodyStart; i < src.length; i++) {
    switch (src[i]) {
      case '\\':
        i++;
        break;
      case '`':
      case '\'':
      case '"':
      case '/':
        if (lastStringStart) {
          if (lastStringStart === src[i]) {
            lastStringStart = null;
          }
        } else {
          lastStringStart = src[i];
        }
        break;
      case '{':
        if (lastStringStart) break;
        stack.push('{');
        break;
      case '}':
        if (lastStringStart) break;
        stack.pop();
        if (!stack.length) return i;
        break;
    }
  }
}

/**
 * Extract params
 * @param {string} params
 * @returns {Object[]}
 */
function extractParams(params) {
  if (!params.trim().length) return [];
  var stack = [];
  var actParam = '';
  var result = [];
  for (var i = 0; i < params.length; i++) {
    switch (params[i]) {
      case '{':
        stack.push('{');
        actParam += params[i];
        break;
      case '}':
        stack.pop();
        actParam += params[i];
        break;
      case ',':
        if (!stack.length) {
          result.push(actParam);
          actParam = '';
          break;
        }
        actParam += params[i];
        break;
      default:
        actParam += params[i];
    }
  }

  result.push(actParam);

  var destructIndex = 0;
  return result.map(function (param) {
    var _param$split$map = param.split('=').map(function (part) {
      return part.trim();
    }),
        _param$split$map2 = _slicedToArray(_param$split$map, 2),
        name = _param$split$map2[0],
        defaultValue = _param$split$map2[1];

    return {
      accessor: name,
      name: name.includes('{') ? 'param' + destructIndex++ : name,
      defaultValue: defaultValue
    };
  });
}

module.exports = findFunctions;


//////////////////
// WEBPACK FOOTER
// ../lib/findFunctions.js
// module id = 495
// module chunks = 0